import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TypedMemo } from '../common/types';
import { LoadingView } from '../common/views/LoadingView';
import { detectMobileOs, isSafeNext, storeUrl } from './mobileAppLinks';

/** Where `/app/get` sends a browser. Split out so a test can check it without a page load. */
export function getAppTarget(userAgent: string, search: string): string {
  const next = new URLSearchParams(search).get('next');
  const safeNext = isSafeNext(next) ? next : undefined;
  const os = detectMobileOs(userAgent);
  if (os !== undefined) {
    return storeUrl(os, safeNext);
  }
  return safeNext ?? '/app/home';
}

/**
 * `/app/get` — the handoff link in the QR code and the email (design music24-mobile-apps).
 * With the app installed, the phone opens the app and never loads this page. Without it, a phone
 * goes to its store and any other browser goes to the web page in `next`. No sign-in: a phone
 * browser that scans the code has no session.
 */
const GetAppViewComponent: React.FC = () => {
  const { search } = useLocation();

  useEffect(() => {
    window.location.replace(getAppTarget(navigator.userAgent, search));
  }, [search]);

  return <LoadingView />;
};

export const GetAppView = TypedMemo(GetAppViewComponent);
